var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      ![
        'bistAnalysis',
        'work-history-detail',
        'workTest',
        'examination',
        'bist',
        'task',
        'practice',
        'classTest',
        'questions',
        'practiceQuestions',
        'classicQuestions',
        'errQuestions',
        'portrait',
        'user',
        'notice',
        'creatSubject',
        'bookCampusAuth',
        'bookCourse',
        'bookTextbook',
        'bookKnowledge'
      ].includes(_vm.$route.name)
    )?_c('div',{staticClass:"header"},[_vm._m(0),_c('div',{staticClass:"right"},[_c('div',{staticClass:"userInfo",on:{"click":_vm.changeuser}},[_c('el-badge',{staticClass:"item",attrs:{"is-dot":"","hidden":_vm.hasNoitfy}},[_c('span',{staticClass:"userName"},[_vm._v(_vm._s(_vm.studentInfo.studentName))])]),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","disabled":_vm.hasNoitfy,"content":"请先到个人中心绑定邮箱","placement":"bottom-end"}},[_c('span',{staticClass:"userStudentNo"},[_vm._v("学号："+_vm._s(_vm.studentInfo.studentNo))])])],1)])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('img',{attrs:{"src":require("../assets/img/bg_logo.png")}}),_c('span',[_vm._v("数刷刷智慧数学平台")])])
}]

export { render, staticRenderFns }